/**
 * @file
 * Behaviors common to all the site.
 */
(function($, Drupal) {
    'use strict';

    const {BREAKPOINTS, SELECTORS, COLORS, log} = Drupal.theme;

    /**
     * Header script for scroll animation & mobile nav.
     *
     * @type {Drupal~behavior}
     *
     * @prop {Drupal~behaviorAttach} attach
     */
    Drupal.behaviors.header = {
        namespace: 'header',
        debug: false,

        // Selectors
        containerAlert: 'js-header-alert',
        containerNav: 'js-header-bottom',
        selectors: {
            navItemWithSub: '.js-menu__item--has-sub',
            navDropdown: '.js-menu-dropdown',
            navDropdownLinks: '.js-menu-dropdown__item',
            overlay: '.js-overlay',
            mobileBurger: '.js-burger',
            mobileNav: '.js-menu',
        },

        // jQuery elements
        $containerAlert: null,
        $containerNav: null,
        $overlay: null,

        // Classes
        classAlertSticky: 'header-alert--sticky',
        classNavSticky: 'header-bottom--sticky',
        classDropdownOpen: 'menu-dropdown__item--open',
        classBurgerClosed: 'burger--closed',

        // Variables
        isAlertSticky: false,
        isNavSticky: false,
        // Height to scroll before sticking alert.
        heightStickAlert: 30,
        // Height to scroll before sticking nav.
        heightStickNav: 125,
        navBreakpoint: BREAKPOINTS.bkpSwitchTablet,

        /**
         * Basic log function.
         *
         * @param {Object} args
         */
        log(...args) {
            log(this.debug, COLORS.RED, this.namespace, args);
        },

        /**
         * Executed on page load and every request, including Ajax requests.
         *
         * @param {Object} context
         *   Part of the page that change, on a page load, this will be the
         *   document.
         */
        attach(context) {
            if (context === document) {
                this.log('attach', 'page load');

                this.updateHeightsAfterAdverline();
                this.$containerAlert = $('.' + this.containerAlert);
                if (this.$containerAlert.length) {
                    this.initAlert();
                }
                this.$containerNav = $('.' + this.containerNav);
                if (this.$containerNav.length) {
                    this.initNav();
                }
            } else if ($(context).hasClass(this.containerAlert)) {
                this.log('attach', 'ajax reload');
                this.$containerAlert = $(context);
                if (this.$containerAlert.length) {
                    this.initAlert();
                }
            }
        },

        /**
         * Update the heights used for alert and nav sticky after the ads
         * addition.
         */
        updateHeightsAfterAdverline() {
            setTimeout(() => {
                const heightAd = parseInt(SELECTORS.$html.css('padding-top'));
                this.heightStickAlert += heightAd;
                this.heightStickNav += heightAd;
            }, 5000);
        },

        /**
         * Init scroll event for alert.
         */
        initAlert() {
            this.log('initAlert');

            // Scroll behavior.
            this.scrollEventAlerts();
            SELECTORS.$window.on('scroll', () => {
                this.scrollEventAlerts();
            });
        },

        /**
         * Init scroll event for nav and call nav hover & mobile functions.
         */
        initNav() {
            this.log('initNav');

            // Scroll behavior.
            this.scrollEventNav();
            SELECTORS.$window.on('scroll', () => {
                this.scrollEventNav();
            });

            this.$overlay = $(this.selectors.overlay);
            if (this.$overlay.length) {
                // Hover behavior.
                this.setNavHover();
                // Mobile nav.
                this.setMobileNav();
            }
        },

        /**
         * Add sticky class on alert once scrolled enough.
         */
        scrollEventAlerts() {
            const isAlertSticky = window.scrollY > this.heightStickAlert;
            // Do something only if new value is different to avoid spam of DOM update.
            if (this.isAlertSticky !== isAlertSticky) {
                this.log('scrollEventAlerts', 'toggle sticky');
                this.isAlertSticky = isAlertSticky;
                this.$containerAlert.toggleClass(this.classAlertSticky, isAlertSticky);
            }
        },

        /**
         * Add sticky class on nav once scrolled enough.
         */
        scrollEventNav() {
            const isNavSticky = window.scrollY > this.heightStickNav;
            // Do something only if new value is different to avoid spam of DOM update.
            if (this.isNavSticky !== isNavSticky) {
                this.log('scrollEventNav', 'toggle sticky');
                this.isNavSticky = isNavSticky;
                this.$containerNav.toggleClass(this.classNavSticky, isNavSticky);
            }
        },

        /**
         * Set hover behavior for the desktop nav.
         */
        setNavHover() {
            this.log('setNavHover');

            // Toggle overlay on main nav item hover.
            this.$containerNav.find(this.selectors.navItemWithSub).hover(() => {
                // Mouse enter.
                if (SELECTORS.$window.width() > this.navBreakpoint) {
                    this.$overlay.stop().fadeIn('fast');
                }
            }, () => {
                // Mouse leave.
                if (SELECTORS.$window.width() > this.navBreakpoint) {
                    this.$overlay.stop().fadeOut();
                }
            });

            // Toggle sub menu on hover in each dropdowns.
            this.$containerNav.find(this.selectors.navDropdown).each((_index, element) => {
                const $links = $(element).find(this.selectors.navDropdownLinks);
                // Stay open after mouse leave.
                $links.hover((event) => {
                    $links.removeClass(this.classDropdownOpen);
                    $(event.currentTarget).addClass(this.classDropdownOpen);
                });
            });
        },

        /**
         * Toggle mobile nav on burger click.
         */
        setMobileNav() {
            const $mobileBurger = this.$containerNav.find(this.selectors.mobileBurger);
            const $mobileNav = this.$containerNav.find(this.selectors.mobileNav);

            if ($mobileBurger.length && $mobileNav.length) {
                this.log('setMobileNav');

                // Toggle mobile nav.
                $mobileBurger.on('click', (event) => {
                    event.preventDefault();
                    this.log('setMobileNav', 'toggle mobile nav');
                    const isClosed = $mobileNav.is(':hidden');
                    // Update burger icon.
                    $mobileBurger.toggleClass(this.classBurgerClosed, isClosed);
                    // Toggle nav and overlay.
                    if (isClosed) {
                        $mobileNav.slideDown('fast');
                        this.$overlay.stop().fadeIn('fast');
                    } else {
                        $mobileNav.slideUp('fast');
                        this.$overlay.stop().fadeOut('fast');
                    }
                });

                // On resize, clear jQuery style attributes and reset burger icon.
                let timeout = null;
                SELECTORS.$window.resize(() => {
                    // Timeout to avoid the spam of this script.
                    clearTimeout(timeout);
                    timeout = setTimeout(() => {
                        // When switching to screen bigger than Tablet.
                        if (SELECTORS.$window.width() > this.navBreakpoint) {
                            this.log('setMobileNav', 'reset');
                            this.$containerNav.find('[style]').removeAttr('style');
                            $mobileBurger.removeClass(this.classBurgerClosed);
                        }
                    }, 200);
                });
            }
        },
    };

    /**
     * Setup basic accordions.
     * - Head and body must be directly under parent class.
     * - If the head is a link, this script prevent default behavior.
     * - 'open' class is added on the head once opened.
     *
     * @usage:
     * <div class="js-accordion">
     *     <div class="js-accordion__head">Title</div>
     *     <div class="js-accordion__body">Content...</div>
     * </div>
     *
     * @type {Drupal~behavior}
     *
     * @prop {Drupal~behaviorAttach} attach
     */
    Drupal.behaviors.accordions = {
        namespace: 'accordions',
        debug: false,

        // Selectors
        selectors: {
            accordion: '.js-accordion',
            accordionHead: '> .js-accordion__head',
            accordionBody: '> .js-accordion__body',
        },

        // Classes
        classOpen: 'open',

        /**
         * Basic log function.
         *
         * @param {Object} args
         */
        log(...args) {
            log(this.debug, COLORS.BLACK, this.namespace, args);
        },

        /**
         * Executed on page load only.
         *
         * @param {Object} context
         *   Part of the page that change, on a page load, this will be the
         *   document.
         */
        attach(context) {
            if (context === document) {
                this.log('attach', 'page load');
                this.init();
            }
        },

        /**
         * Init each accordion.
         */
        init() {
            $(this.selectors.accordion).each((index, accordion) => {
                this.log('init accordion n°' + index);

                const $accordion = $(accordion);
                const $head = $accordion.find(this.selectors.accordionHead);
                const $body = $accordion.find(this.selectors.accordionBody);

                if ($head.length && $body.length) {
                    $head.on('click', (event) => {
                        event.preventDefault();
                        this.log('toggle accordion n°' + index);

                        $body.slideToggle('fast', () => {
                            // Add class open only if the body isn't hidden.
                            $head.toggleClass('open', !$body.is(':hidden'));
                        });
                    });
                }
            });
        },
    };

    /**
     * Scroll to the top.
     *
     * @type {Drupal~behavior}
     *
     * @prop {Drupal~behaviorAttach} attach
     */
    Drupal.behaviors.scrollTop = {
        // Selectors
        selector: '.js-scroll-top',

        // jQuery elements
        $scrollToTop: null,

        // Variables
        minScrollValue: 200,
        shouldDisplay: false,

        /**
         * Executed on page load only.
         *
         * @param {Object} context
         *   Part of the page that change, on a page load, this will be the
         *   document.
         */
        attach(context) {
            if (context === document) {
                this.$scrollToTop = $(this.selector);
                if (this.$scrollToTop.length) {
                    this.init();
                }
            }
        },

        /**
         * Set scroll event & attach scroll to top animation on click.
         */
        init() {
            this.scrollEvent();
            SELECTORS.$window.on('scroll', () => {
                this.scrollEvent();
            });
            this.$scrollToTop.on('click', (event) => {
                event.preventDefault();
                $('html, body').animate({scrollTop: 0}, 600);
            });
        },

        /**
         * Scroll event, display the link if scroll > minScrollValue.
         */
        scrollEvent() {
            const shouldDisplay = window.scrollY > this.minScrollValue;
            // Do something only if new value is different to avoid spam of DOM update.
            if (this.shouldDisplay !== shouldDisplay) {
                this.shouldDisplay = shouldDisplay;
                this.$scrollToTop.fadeToggle(shouldDisplay);
            }
        },
    };
})(jQuery, Drupal);
